import { useState } from "react";
import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function FaqSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  const faqs = [
    { q: t("faq.q1"), a: t("faq.a1") },
    { q: t("faq.q2"), a: t("faq.a2") },
    { q: t("faq.q3"), a: t("faq.a3") },
    { q: t("faq.q4"), a: t("faq.a4") },
  ];

  return (
    <section id="faq" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{t("faq.title")}</h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <button
                onClick={() => setOpen(open === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading font-semibold text-sm md:text-base text-foreground-900">{faq.q}</span>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 text-foreground-500">
                  <i className={`${open === idx ? "ri-subtract-line" : "ri-add-line"} text-lg`}></i>
                </span>
              </button>
              {open === idx && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Final CTA */}
        <div className="mt-12 text-center rounded-lg bg-primary-500 px-6 py-10">
          <h3 className="font-heading font-bold text-xl md:text-2xl text-background-50">{t("articleEntry.cardTitle")}</h3>
          <p className="text-sm text-background-100/90 mt-3 max-w-xl mx-auto">{t("footer.aboutDesc")}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3 rounded-md bg-background-50 text-primary-700 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              {t("hero.ctaPrimary")}
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              {t("hero.ctaSecondary")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}